import React from "react";
import { BallCanvas } from "./canvas";
import { SectionWrapper } from "../hoc";
import { technologies } from "../constants";

const Tech = () => {
  return (
    <div className="flex flex-row flex-wrap justify-center gap-10 ">
      {technologies?.map((technology) => (
        <div className="flex flex-col items-center justify-center space-y-2 cursor-pointer" key={technology.name}>
          {/* <BallCanvas icon = { technology.icon } /> */}
          <div className="w-28 h-28 rounded-full overflow-hidden">
            <img
              src={technology.icon}
              alt={technology.name}
              className="w-full h-full object-cover "
            />
          </div>

          <p className="text-white">{technology.name}</p>

        </div>
      ))}
    </div>
  );
};

export default SectionWrapper(Tech, "");
